export enum DocTypeEnum {
  CreateCloneProjectDialog,
  ConfigureProjectStep,
}

export const DocLinkUrl = {
  [DocTypeEnum.CreateCloneProjectDialog]:
    'https://staging-fp.atlassian.net/wiki/spaces/SD/pages/171835469/SOP+Tactical+CFI',
  [DocTypeEnum.ConfigureProjectStep]:
    'https://staging-fp.atlassian.net/wiki/spaces/SD/pages/171835469/SOP+Tactical+CFI#1.-Configure-project-(Phase-0)',
};
